export enum RequestViews {
  Editor = "editor",
  Summary = "summary",
  Compare = "compare",
  Search = "search",
  Start = "start",
  Customization = "customization",
  None = "none"
}